import React, { useState, useEffect } from 'react';

const BotaoUrgencia = () => {
  // 🕒 Configuração do Tempo (15 minutos)
  const initialTime = 15 * 60;
  const [timeLeft, setTimeLeft] = useState(initialTime);

  // 🔗 Link Hotmart (checkout em nova aba)
  const checkoutLink = "https://pay.hotmart.com/Q103046465Y?checkoutMode=10";

  useEffect(() => {
    // Lógica do cronômetro
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);

    // Otimização: Preconnect para Hotmart
    const domains = [
      "https://pay.hotmart.com",
      "https://static.hotmart.com"
    ];

    domains.forEach(domain => {
      if (!document.querySelector(`link[rel="preconnect"][href="${domain}"]`)) {
        const link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = domain;
        document.head.appendChild(link);
      }
    });

    return () => clearInterval(timer);
  }, []);

  // Formata o tempo (MM:SS)
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? '0' : ''}${secs}`;
  };

  // Pixel + Clique
  const handleClick = () => {
    if (typeof window.fbq !== 'undefined') {
      window.fbq('track', 'InitiateCheckout', {
        content_name: 'Oferta Downsell R$147 (Luxo)',
        value: 147.00,
        currency: 'BRL'
      });
    }
  };

  return (
    // CARD PRINCIPAL: Branco, Sombra Suave, Bordas Arredondadas
    <div className="flex flex-col items-center justify-center p-8 bg-white rounded-3xl shadow-2xl max-w-md mx-auto my-10 border border-gray-100">

      {/* Cabeçalho: Ícone e Texto Discreto */}
      <div className="flex items-center gap-2 mb-6">
        <span className="animate-pulse h-3 w-3 rounded-full bg-red-500"></span>
        <p className="text-gray-500 text-sm font-medium tracking-widest uppercase">
          Oferta por tempo limitado
        </p>
      </div>

      {/* O Contador Minimalista */}
      <div className="text-5xl font-light text-gray-800 mb-6 font-mono tracking-tighter">
        {formatTime(timeLeft)}
      </div>

      {/* Preço: Hierarquia Visual Clara */}
      <div className="text-center mb-8">
        <p className="text-gray-400 text-lg line-through font-light decoration-red-400">
          De R$ 297,00
        </p>
        <div className="flex items-center justify-center gap-1">
          <span className="text-2xl text-gray-700 font-light">Por</span>
          <span className="text-4xl text-emerald-600 font-bold tracking-tight">
            R$ 147,00
          </span>
        </div>
      </div>

      {/* O Botão: Gradiente Esmeralda + Sombra Colorida */}
      <a
        href={checkoutLink}
        target="_blank"
        rel="noopener noreferrer"
        className="w-full block text-center bg-gradient-to-r from-emerald-500 to-emerald-700 hover:from-emerald-600 hover:to-emerald-800 text-white text-lg font-semibold py-4 px-8 rounded-xl shadow-lg shadow-emerald-200 transform transition-all duration-300 hover:-translate-y-1 cursor-pointer no-underline"
        onClickCapture={handleClick}
      >
        Desbloquear Desconto
      </a>

      {/* Rodapé: Garantia */}
      <div className="mt-6 flex items-center justify-center gap-2 text-gray-400 text-xs">
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
        </svg>
        <span>Compra 100% Segura e Criptografada</span>
      </div>
    </div>
  );
};

export default BotaoUrgencia;
